import { createFileRoute } from "@tanstack/react-router";
import { getCity } from "@/lib/seo/cities";
import { employerBrandingForCity } from "@/lib/seo/cityHubCopy";
import { cityHubRoute } from "@/lib/seo/cityHubRoute";

const city = getCity("solna")!;
const page = employerBrandingForCity(city);

export const Route = createFileRoute("/employer-branding-film_/solna")(cityHubRoute(city, page));
